import React from 'react';
import RequireEvent from '../../components/RequireEvent';
import { choose } from '../../utils/platform';
import { useServices } from './useServices';
import ServicesDesktop from './Services.desktop';
import ServicesMobile from './Services.mobile';

const ServicesView = choose(ServicesDesktop, ServicesMobile);

function ServicesInner({ event }) {
  const vm = useServices(event);
  return <ServicesView vm={vm} />;
}

export default function Services() {
  return <RequireEvent>{(event) => <ServicesInner event={event} />}</RequireEvent>;
}
